import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import utils from '../utils/utils'

const store = new Vuex.Store({
    state: {
        pluginList: [],
        playingPluginIndex: 0, //唯一播放组件  全局联动，用于停止其他组件播放
        // currentPluginIndex:0,
        // lastAddPluginCount:0,
        // rightTabName:"form",//"plugin",
        formSettings: {
            title: "",
            desc: "",
            opening: "weapp",
            cover: "/static/images/icon/diy.png",
            start_time: "",
            end_time: "",
            max_views: 0,
            multipleForm: false,//一页中有多个表单名
        },
        // config
        config: {
            apiDomain: '',
            qrScene: '',
            tbScene: '',
            formDataUrl: '',
            isSubmitPwd: 0,
            isNotRepeat: 0,
            formDataList: {},
            qrData: {},
        },
        submitPluginIndex: null,//提交按钮
        submitDisabled: false,//防重复提交
        formSubmitPwd: '',//表单密码
    },
    getters: {
        // editablePageData:(state,getters)=>{
        //     return state.pageList.find((item)=> item.page== state.editablePage)
        // },
        // editablePageIndex:(state)=>{
        //     return state.pageList.findIndex((item)=> item.page== state.editablePage)
        // },
        // currentPlugin:(state,getters)=>{
        //     return  state.pluginList[state.currentPluginIndex] || null
        // },
        // pageTotal:(state)=>{
        //     return state.pageList.length
        // }
    },
    mutations: {
        setPlayingPluginIndex(state, index) {
            state.playingPluginIndex = index;
        },
        setFormSubmitPwd(state, formSubmitPwd) {
            // console.log('pluginList',pluginList)
            state.formSubmitPwd = formSubmitPwd
        },
        setPluginList(state, pluginList) {
            // console.log('pluginList',pluginList)
            state.pluginList = pluginList
        },
        setFormSettings(state, formSettings) {
            state.formSettings = formSettings
        },
        setConfig(state, config) {
            // console.log('config',config)
            state.config = config
        },
        setSubmitIndex(state, index) {
            state.submitPluginIndex = index
        },
        actionPlugin(state, options) {
            const { pluginIndex, field, itemIndex, groupIndex } = options
            let pluginData = state.pluginList[pluginIndex] || null

            // console.log('actionPlugin',pluginData);

            if (!pluginData) {
                return;
            }


            var pluginName = pluginData.name;
            if (field && itemIndex !== undefined) {
                if (field == 'groups') { // collapse plugin
                    pluginData = pluginData?.groups[groupIndex].grids[itemIndex];
                } else {
                    pluginData = pluginData[field][itemIndex]
                }

            }

            if (!pluginData) {
                return;
            }

            // console.log('pluginData', pluginData);

            // if(pluginName=="kefu" || pluginName=="nuoChe"){ //这两个在各组件实现
            // //    console.log(field,pluginData);
            //     if(field=="wechat"){
            //         if(pluginData.url==''){
            //             console.log('url empty')
            //             return ;
            //         }
            //         this.showWechatQr = true;
            //         this.wechatQr = pluginData.url;
            //     }else{
            //         if(pluginData.tel==''){
            //             console.log('tel empty')
            //             return ;
            //         }
            //         //tel
            //         location.href="tel://"+pluginData.tel;
            //     }
            // }else 

            if (field == "qrList") {
                if (pluginData.qrScene == '') {
                    console.log('qrScene empty')
                    return;
                }
                var qr_type = pluginName.replace('qr', '').toLowerCase();
                var _link = 'https://v.2weima.com/' + qr_type + '.html?qr_scene=' + pluginData.qrScene;
                //网页跳转link
                utils.handleLink(_link)
            }
            else if (pluginData.handle == "link") {

                // console.log('pluginData link', pluginData)
                if (pluginData.link == '') {
                    // h5打开小程序
                    if (pluginData.path != '' && pluginData.appId != '') {
                        pluginData.link = 'weixin://dl/business/?appid=' + pluginData.appId + '&path=' + pluginData.path;

                        // console.log('h5打开小程序 link', pluginData.link)
                    } else {

                        // console.log('link empty')
                        return;
                    }
                }
                utils.handleLink(pluginData.link)
            } else if (pluginData.handle == "message") {
                if (pluginData.message == '') {
                    console.log('message empty')
                    return;
                }
                utils.handleMessage(pluginData.message)
            } else if (pluginData.handle == 'copy') {
                utils.handleCopy(pluginData?.handle_copy);

            } else if (pluginData.handle == 'call') {

                utils.handleCall(pluginData?.handle_call);


            }
            else if (pluginData.handle == 'map') {

                utils.handleMap(pluginData?.handle_map);


            }
            else if (pluginData.handle == 'wifi') {

                utils.handleWifi(pluginData?.handle_wifi);

            }else if (pluginData.handle == 'images') {

                // 查看大图
                utils.handelImages(pluginData?.handle_images);

            }
            else {
                // none or default
                // console.log('none')
                if (pluginName == 'swipe' || pluginName == 'image' || pluginName == 'imageGrid') {
                    //无动作 查看大图
                    // console.log('pluginData',pluginData)

                    if (pluginData.url == '') {
                        console.log('url empty')
                        return;
                    }

                    utils.handelImagePreview(pluginData.url);
                }

            }
        },
        // removePlugin(state,index){
        //     state.pluginList.splice(index,1);
        //     // 选中
        //     state.currentPluginIndex = index>0 ? index-1 : 0;//变更当前选中

        // },
    }
})

export default store;